<script setup>
import { computed, ref, watch } from "vue";

import BaseModal from "@/components/ui/BaseModal.vue";
import { stores } from "@/data/stores";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "confirmed"]);

const selectedAlcaldia = ref("");
const selectedStore = ref("");

const alcaldias = computed(() => [
  ...new Set(stores.map((store) => store.alcaldia).filter(Boolean)),
]);

const availableStores = computed(() => {
  if (!selectedAlcaldia.value) {
    return stores;
  }

  return stores.filter((store) => store.alcaldia === selectedAlcaldia.value);
});

const canConfirm = computed(() =>
  Boolean(selectedAlcaldia.value && selectedStore.value)
);

watch(selectedAlcaldia, () => {
  const exists = availableStores.value.some(
    (store) => store.id === selectedStore.value
  );

  if (!exists) {
    selectedStore.value = "";
  }
});

watch(
  () => props.modelValue,
  (isOpen) => {
    if (!isOpen) {
      selectedAlcaldia.value = "";
      selectedStore.value = "";
    }
  }
);

function close() {
  emit("update:modelValue", false);
}

function confirm() {
  const store = stores.find((item) => item.id === selectedStore.value);

  if (!store) {
    return;
  }

  emit("confirmed", store);
  close();
}
</script>

<template>
  <BaseModal
    :model-value="modelValue"
    title="¿Dónde quieres comprar?"
    description="Elige tu alcaldía y tienda."
    size="md"
    @update:model-value="close"
  >
    <form class="store-locator" @submit.prevent="confirm">
      <label class="store-locator__field">
        <span>Alcaldía</span>

        <div class="store-locator__select">
          <select v-model="selectedAlcaldia" required>
            <option value="" disabled>Selecciona una alcaldía</option>

            <option
              v-for="alcaldia in alcaldias"
              :key="alcaldia"
              :value="alcaldia"
            >
              {{ alcaldia }}
            </option>
          </select>

          <ion-icon name="chevron-down-outline" aria-hidden="true"></ion-icon>
        </div>
      </label>

      <label class="store-locator__field">
        <span>Tienda</span>

        <div class="store-locator__select">
          <select
            v-model="selectedStore"
            :disabled="!selectedAlcaldia"
            required
          >
            <option value="" disabled>Selecciona una tienda</option>

            <option
              v-for="store in availableStores"
              :key="store.id"
              :value="store.id"
            >
              {{ store.name }}
            </option>
          </select>

          <ion-icon name="chevron-down-outline" aria-hidden="true"></ion-icon>
        </div>
      </label>

      <button
        type="submit"
        class="store-locator__primary"
        :disabled="!canConfirm"
      >
        Confirmar tienda
      </button>

      <button type="button" class="store-locator__secondary" @click="close">
        Cerrar
      </button>
    </form>
  </BaseModal>
</template>